export default __webpack_public_path__ + "static/media/ui_tap-variant-01.204f5440.wav";